import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.button`
    align-items: center;
    background: ${props => (props.color)};
    border: none;
    border-radius: 15px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 50px;
    justify-content: center;
    outline: none;
    width: fit-content;
    width: 150px;
    @media (min-width: 720px) {
        height: 101.32px;
        width: 286.773px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 50px;
        width: 150px;
    }
`;

export const TitleContainer = styled.h1`
    color: #FFF;
    font-size: 21px;
    font-style: normal;
    font-weight: 700;
    line-height: 101.008%; 
    text-align: center;
    text-align: center;
    width: 100%;
`;

export const ValueContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 5px;
    justify-content: center;
    max-width: 80%;
    width: 80%;
`;

export const ValueText = styled.span`
    color: #FFF;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    max-width: 80%;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ValueUnit = styled.span` 
    color: #FFF;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const CardPlaceHolderContainer = styled.button`
    align-items: center;
    background: transparent;
    border: 2px dashed ${props => (props.color)};
    border-radius: 15px;
    cursor: pointer;
    display: flex;
    height: 50px;
    justify-content: center;
    outline: none;
    padding: 15px;
    width: 150px;
    @media (min-width: 720px) {
        height: 101.32px;
        width: 286px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 50px;
        width: 150px;
    }
`;

export const SvgIcon = styled(SVG)`
    align-self: center;
    height: 35px;
    width: 35px;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 720px) {
        height: 68px;
        width: 68px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 35px;
        width: 35px;
    }
`;